import React from 'react';
import './SplashScreen.css';

const SplashScreen = () => (
  <div className="splash-screen">
    <div className="splash-content" role="status" aria-live="polite">
      <div className="splash-brand-card">
        <div className="splash-logo-shell" aria-hidden>
          <img src="/branding/cb-app-logo-circle.svg" alt="" className="splash-logo" />
        </div>
        <h1 className="splash-title">cbonline app</h1>
        <p className="splash-subtitle">Fast, clean, and ready for your business day.</p>
        <div className="loader" aria-hidden></div>
      </div>
    </div>
  </div>
);

export default SplashScreen;
